<template lang="html">
  <div :class="['custom-radio','is-' + state]">
    <d-form-radio v-model="value" :value="true" :state="state">Sim</d-form-radio>
    <d-form-radio v-model="value" :value="false" :state="state">Não</d-form-radio>
  </div>
</template>

<script>
export default {
  name: 'input-string',
  props: {
    model: {
      type: Boolean,
    },
    state: {
      type: String,
      default: null,
    },
  },
  computed: {
    value: {
      get() {
        return this.model;
      },
      set(value) {
        return this.$emit('update:model', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
